import type { HistoryAdapterNavigate } from "@sanity/visual-editing";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router";
import { api, Tag } from "../state/api";
import { useTypedDispatch } from "../state/store";
import { setPlaybookPerspective } from "../utilities/playbook";

export const SanityEditor = () => {
  const location = useLocation();
  const onNavigateRef = useRef<HistoryAdapterNavigate | null>(null);
  useEffect(() => {
    if (onNavigateRef.current) {
      onNavigateRef.current({ type: "push", url: location.pathname });
    }
  }, [location]);

  const dispatch = useTypedDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    import("@sanity/visual-editing").then(({ enableVisualEditing }) => {
      enableVisualEditing({
        onPerspectiveChange: (perspective) => {
          setPlaybookPerspective(
            Array.isArray(perspective) ? perspective[0] : perspective,
          );
        },
        refresh: ({ source }) => {
          if (source === "mutation") {
            dispatch(api.util.invalidateTags([Tag.Playbook]));
          } else {
            window.location.reload();
          }
          return Promise.resolve();
        },
        history: {
          subscribe: (navigate) => {
            onNavigateRef.current = navigate;
            return () => {
              onNavigateRef.current = null;
            };
          },
          update: (update) => {
            switch (update.type) {
              case "push":
                navigate(update.url);
                return;
              case "pop":
                navigate(-1);
                return;
              case "replace":
                navigate(update.url, { replace: true });
                return;
            }
          },
        },
      });
    });
  }, [dispatch, navigate]);

  return null;
};
